var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "kw-container" }, [
    _c(
      "div",
      { staticClass: "kw", class: { max: _vm.isMaximized } },
      [
        _vm.uniqKeywords.length > 0
          ? _c(
              "transition-group",
              {
                staticClass: "keywords",
                attrs: { name: "keyword-list", tag: "ul" },
              },
              [
                _vm._l(_vm.selectedKeywordsWithCount, function (keywordObj) {
                  return _c("RecipeKeyword", {
                    key: keywordObj.name,
                    staticClass: "keyword active",
                    attrs: {
                      name: keywordObj.name,
                      count: keywordObj.count,
                      title: _vm.t("cookbook", "Toggle keyword"),
                    },
                    on: {
                      "keyword-clicked": function ($event) {
                        return _vm.keywordClicked(keywordObj)
                      },
                    },
                  })
                }),
                _vm._v(" "),
                _vm._l(_vm.selectableKeywords, function (keywordObj) {
                  return _c("RecipeKeyword", {
                    key: keywordObj.name,
                    staticClass: "keyword",
                    attrs: {
                      name: keywordObj.name,
                      count: keywordObj.count,
                      title: _vm.t("cookbook", "Toggle keyword"),
                    },
                    on: {
                      "keyword-clicked": function ($event) {
                        return _vm.keywordClicked(keywordObj)
                      },
                    },
                  })
                }),
                _vm._v(" "),
                _vm._l(_vm.unavailableKeywords, function (keywordObj) {
                  return _c("RecipeKeyword", {
                    key: keywordObj.name,
                    staticClass: "keyword disabled",
                    attrs: {
                      name: keywordObj.name,
                      count: keywordObj.count,
                      "title":// prettier-ignore
                    _vm.t('cookbook','Keyword not contained in visible recipes'),
                    },
                    on: {
                      "keyword-clicked": function ($event) {
                        return _vm.keywordClicked(keywordObj)
                      },
                    },
                  })
                }),
              ],
              2
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "settings-buttons" }, [
      _c(
        "button",
        {
          staticClass: "ordering-button",
          attrs: { title: _vm.orderButtonTitle },
          on: { click: _vm.toggleOrderCriterium },
        },
        [_vm._v("\n            " + _vm._s(_vm.orderButtonText) + "\n        ")]
      ),
      _vm._v(" "),
      _c("button", {
        class: _vm.toggleSizeIcon,
        attrs: { title: _vm.t("cookbook", "Toggle keyword area size") },
        on: { click: _vm.toggleCloudSize },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }